<template>
  <div class="standardpage">
    <b-card>
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="options.icon" class="mr-1"></i>
            <!-- {{ addRow ? "New Car Booking" : options.title }} -->
            <span>{{ options.title }}</span>
          </b-col>
          <!-- <b-col cols="12" sm="6" class="mt-2 mt-sm-0">
            <div class="card-header-actions">
              <div style="display: flex; justify-content: space-between">
                <b-button
                  @click="showfilter = !showfilter"
                  :pressed="!showfilter"
                  variant="outline-primary"
                  class="card-header-action mr-1"
                  squared
                  size="sm"
                  title="Show/Hide Filter"
                >
                  <i class="fa fa-filter"></i
                ></b-button>
                <b-form-group size="sm" class="mb-0">
                  <b-input-group>
                    <b-form-input
                      size="sm"
                      v-model="btable_find"
                      placeholder="Find"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        style="width: auto; padding: 0.25rem 0.6rem"
                        variant="outline-primary"
                        :disabled="!btable_find"
                        @click="btable_find = ''"
                      >
                        <i v-if="btable_find" class="fa fa-remove"></i>
                        <i v-if="!btable_find" class="fa fa-search"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
          </b-col> -->
        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">
            <!-- <b-row no-gutters v-if="showfilter">
              <b-col>
                <b-button
                  @click="showfilter = !showfilter"
                  variant="link"
                  class="card-header-action"
                  squared
                  size="sm"
                >
                  <i class="fa fa-filter pr-2"></i>Filter...</b-button
                >
              </b-col>
          
            </b-row> -->
            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <!-- <b-col cols="auto"> -->
                <b-form-group
                  label-cols="12"
                  label="Date Pickup"
                  label-size="sm"
                >
                  <!-- :timePicker="true"
                      :timePicker24Hour="true" -->
                  <b-input-group>
                    <daterangepicker
                      size="sm"
                      ref="datepickup"
                      v-model="datepickup"
                      :opens="'right'"
                      :locale-data="locale_data"
                      :ranges="locale_ranges"
                      :showDropdowns="true"
                      :linkedCalendars="true"
                      :single-date-picker="'range'"
                    >
                    </daterangepicker>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        @click="
                          datepickup = {
                            startDate: null,
                            endDate: null,
                          }
                        "
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Date Pickup From"
                  label-size="sm"
                >
                  <b-input-group>
                    <b-form-datepicker
                      size="sm"
                      v-model="datepickupfrom"
                      label-help
                      hide-header
                      locale="en-GB"
                      placeholder="From"
                      :debounce="options.debounce"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>

                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!datepickupfrom"
                        @click="datepickupfrom = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Date Pickup To"
                  label-size="sm"
                >
                  <b-input-group>
                    <b-form-datepicker
                      size="sm"
                      v-model="datepickupto"
                      label-help
                      hide-header
                      placeholder="To"
                      locale="en-GB"
                      :debounce="options.debounce"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    ></b-form-datepicker>

                    <b-input-group-append>
                      <b-button
                        size="sm"
                        squared
                        variant="outline-secondary"
                        :disabled="!datepickupto"
                        @click="datepickupto = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col> -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Status" label-size="sm">
                  <treeselect
                    placeholder="Select status..."
                    v-model="status"
                    :clearable="true"
                    :options="status_options"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                  >
                    <!-- <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div> -->
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Agent" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="agent"
                      :debounce="options.debounce"
                      placeholder="Agent"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!agent"
                        @click="agent = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="12" sm="6" md="4" xl="3">
                  <b-form-group
                    label="Future Pickup?"
                    label-for="isfuture"
                    label-cols="12"
                    label-size="sm"
                    id="isfuture"
                  >
                    <b-input-group>
                      <b-form-radio-group
                        v-model="isfuture"
                        :options="[
                          { text: 'YES', value: 'true' },
                          { text: 'NO', value: 'false' },
                        ]"
                        buttons
                        button-variant="outline-success"
                        size="sm"
                        name="radio-btn-outline"
                        :debounce="options.debounce"
                        class="small-xs"
                      ></b-form-radio-group>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          variant="outline-secondary"
                          @click="isfuture = null"
                        >
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-tooltip target="isfuture" triggers="hover"
                  >Displays future pick up dates.</b-tooltip
                > -->
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Driver" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="driver"
                      :debounce="options.debounce"
                      placeholder="Driver"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!driver"
                        @click="driver = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Client SL A/C"
                  label-size="sm"
                >
                  <treeselect
                    placeholder="Select slac..."
                    searchPromptText="Type at least 3 chars..."
                    v-model="slac"
                    :clearable="true"
                    :async="true"
                    :load-options="treeselect_loadSLAC"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Event" label-size="sm">
                  <treeselect
                    placeholder="Select event..."
                    searchPromptText="Type at least 4 chars..."
                    v-model="eventcode"
                    :clearable="true"
                    :async="true"
                    :load-options="treeselect_loadEvent"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>

              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Supplier BL A/C"
                  label-size="sm"
                >
                  <treeselect
                    placeholder="Select blac..."
                    searchPromptText="Type at least 3 chars..."
                    v-model="blac"
                    :clearable="true"
                    :async="true"
                    :load-options="treeselect_loadBLAC"
                    :show-count="true"
                    :flatten-search-results="true"
                    :disable-branch-nodes="true"
                    :matchKeys="['id']"
                    search-nested
                  >
                    <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div>
                  </treeselect>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group
                  label-cols="12"
                  label="Confirmation No"
                  label-size="sm"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="confirmationno"
                      :debounce="options.debounce"
                      placeholder="Confirmation No"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!confirmationno"
                        @click="confirmationno = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Invoice" label-size="sm">
                  <b-input-group>
                    <b-form-input
                      v-model="invoiceno"
                      :debounce="options.debounce"
                      placeholder="Invoice"
                      trim
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        size="sm"
                        variant="outline-secondary"
                        :disabled="!invoiceno"
                        @click="invoiceno = ''"
                      >
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <b-row class="px-0 mt-0">
            <b-col cols="auto">
              <b-button-group class="z-0">
                <b-row align-h="start" no-gutters>
                  <b-col
                    class="gridtoolbar"
                    cols="auto"
                    v-for="(tool, index) in tools.filter(
                      (o) => o.position == 'toolbar'
                    )"
                    :key="index"
                  >
                    <b-button
                      v-if="tool.type == 'button'"
                      :id="'tool_' + tool.action"
                      :size="tool.size"
                      :variant="tool.variant"
                      :title="tool.title ? tool.title : toolLabel(tool)"
                      :squared="tool.squared ? 'squared' : null"
                      :disabled="toolDisabled(tool.action)"
                      @click="toolClick(tool.action)"
                    >
                      <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
                      <span v-if="toolLabel(tool)" v-html="toolLabel(tool)">
                      </span>
                      <i v-if="tool.icon2" :class="tool.icon2"></i>
                    </b-button>
                  </b-col>
                </b-row>
              </b-button-group>
            </b-col>
            <b-col>
              <b-row align-h="end" no-gutters>
                <b-col
                  cols="auto"
                  v-for="(tool, index) in options.view"
                  :key="index"
                >
                  <span v-if="tool.type == 'label'" :class="tool.class">
                    {{ tool.label }}
                  </span>
                  <b-form-radio-group
                    v-if="tool.type == 'radio-group'"
                    :options="tool.options"
                  >
                  </b-form-radio-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="px-3">
          <b-overlay
            :show="options.overlay_show"
            opacity=".9"
            v-click-outside="outside"
          >
            <div>
              <b-table
                :dark="$store.state.darkMode"
                ref="btable"
                :sticky-header="btable_height + 'px'"
                striped
                hover
                small
                caption-bottom
                show-empty
                selectable
                select-mode="multi"
                :busy="btable_busy"
                :items="btable_items"
                :fields="options.fields"
                :filter="btable_find"
                @row-selected="btable_rowSelected"
              >
                <template #head(selected)>
                  <i
                    id="selectall"
                    class="ml-1"
                    :class="btable_iconselected()"
                    aria-hidden="true"
                    @click="btable_iconselectedClick()"
                    title="Click to select/unselect all"
                  ></i>
                  <b-tooltip
                    target="selectall"
                    triggers="hover"
                    placement="right"
                    >Click to select/unselect all</b-tooltip
                  >
                </template>
                <template #cell(selected)="{ rowSelected }">
                  <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                  </template>
                  <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                  </template>
                </template>
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner
                      type="grow"
                      variant="primary"
                      class="align-middle mr-2"
                    ></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)="slot">
                  <i :class="btable_icon(slot.item)"></i>
                </template>

                <template v-slot:cell()="row">
                  <div
                    v-if="
                      options.badges &&
                      options.badges.find((obj) => obj.key == row.field.key)
                    "
                  >
                    <span
                      v-html="
                        btable_rowBadgeCell(
                          row.item,
                          options.badges.find(
                            (obj) => obj.key == row.field.key
                          ),
                          options
                        )
                      "
                    ></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button
                      variant="link"
                      size="sm"
                      title="Actions"
                      :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')"
                    >
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover
                      container="actions-container"
                      triggers="click blur"
                      placement="leftbottom"
                      :target="'popover-target-' + row.item.id"
                    >
                      <div>
                        <b-nav vertical>
                          <b-nav-item
                            :title="action.label"
                            v-for="action in btable_rowActionCell(
                              row.item,
                              options
                            )"
                            :key="action.key"
                            @click.stop="btable_rowClick(action.key, row)"
                          >
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i
                                  :class="
                                    btable_rowActionIcon(action, row.item)
                                  "
                                ></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button
                      variant="link"
                      size="sm"
                      v-for="action in btable_rowActionCell(row.item, options)"
                      :key="action.key"
                      @click.stop="btable_rowClick(action.key, row)"
                      :title="action.label"
                    >
                      <i :class="btable_rowActionIcon(action, row.item)"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details>
                  <b-card>
                    <component
                      :is="options.component.name"
                      :selection="btable_selected"
                      :config="cconfig"
                      @discard="toolClick('discard')"
                      @refresh="toolClick('refresh')"
                    ></component>
                  </b-card>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button
                      v-for="(button, index) in options.overlay.buttons"
                      :key="index"
                      :style="button.style ? button.style : 'width: 80px'"
                      :class="
                        button.class
                          ? button.class
                          : button.dispatch
                          ? null
                          : 'ml-2'
                      "
                      :variant="
                        button.variant
                          ? button.variant
                          : button.dispatch
                          ? 'outline-primary'
                          : 'outline-secondary'
                      "
                      :size="button.size ? button.size : 'sm'"
                      :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? toolClick(button.dispatch)
                          : (options.overlay_show = false)
                      "
                      >{{ button.label }}</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
        </div>
      </div>

      <div v-if="component">
        <component
          :is="component"
          :selection="btable_selected"
          :config="cconfig"
          @saveit="saveit"
          @discard="toolClick('discard')"
          @refresh="toolClick('refresh')"
        ></component>
      </div>

      <b-row v-if="!component" class="excelsheetbuttons px-3" no-gutters>
        <b-col>
          <div v-if="btable_busy">
            <i class="fa fa-spinner fa-spin text-primary"></i>
            <span class="small text-primary ml-1">Updating ...</span>
          </div>
          <span v-if="!btable_busy" class="small text-primary"
            >Found {{ rows }} rows</span
          >
        </b-col>
        <b-col class="text-right">
          <b-pagination
            hide-ellipsis
            v-model="currentpage"
            :total-rows="rows"
            :per-page="limit"
            align="right"
            size="sm"
          ></b-pagination>
        </b-col>
        <b-col class="ml-2" cols="auto">
          <div class="pagelimit">
            <treeselect
              v-model="limit"
              :clearable="false"
              :options="options_pagesizes"
              size="sm"
              inline
            ></treeselect>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

import CarBookingsEdit from "./Components/CarBookingsEdit";
import CarInvoiceEdit from "./Components/CarInvoiceEdit";
import CarVoucher from "./Components/CarVoucher";

export default {
  name: "CarBookings",
  components: {
    CarBookingsEdit,
    CarInvoiceEdit,
    CarVoucher,
  },
  watch: {
    async datepickup() {
      await this.load();
    },

    // async datepickupfrom() {
    //   this.datepickupto = null;
    //   if (this.datepickupfrom) {
    //     this.datepickupto = this.$moment(this.datepickupfrom)
    //       .add(6, "months")
    //       .format("YYYY-MM-DD");
    //   }
    //   await this.load();
    // },
    // async datepickupto() {
    //   await this.load();
    // },
    async status() {
      await this.load();
    },
    async agent() {
      await this.load();
    },
    async driver() {
      await this.load();
    },
    async slac() {
      await this.load();
    },
    async eventcode() {
      await this.load();
    },
    async blac() {
      await this.load();
    },
    async confirmationno() {
      await this.load();
    },
    async invoiceno() {
      await this.load();
    },
  },
  data() {
    return {
      status: null,
      datepickup: {
        startDate: this.$moment().add(-2, "months").format("YYYY-MM-DD"),
        endDate: this.$moment().add(6, "months").format("YYYY-MM-DD"),
      },
      slac: null,
      blac: null,
      driver: null,
      eventcode: null,
      agent: null,
      confirmationno: null,
      invoiceno: null,
      status_options: [
        { id: "ST", label: "New" },
        { id: "WI", label: "Pending" },
        { id: "ID", label: "Invoiced" },
        { id: "AA", label: "On Hold" },
        { id: "CX", label: "Cancelled" },
        { id: "IF", label: "Failed (unused)" },
        { id: "IQ", label: "Queued (unused)" },
        { id: "VD", label: "Vouchered (unused)" },
      ],

      search: {
        event: null,
        event_name: "",
        date: null,
        selected: null,
      },
      criteria: {
        events: [],
      },
      options: {
        title: "Car Bookings",
        icon: "fa fa-car",
        debounce: 500,
        tools: [
          {
            type: "button",
            size: "sm",
            variant: "outline-white",
            squared: "squared",
            icon: "fa fa-search-plus pr-1",
            position: "toolbar",
            action: "view",
            label: "Voucher",
            component: {
              name: "",
            },
          },
        ],
        view: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-30px",
          },
          {
            key: "driver",
            label: "Driver",
            sortable: true,
          },
          {
            key: "slac",
            label: "SL A/C",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
          {
            key: "eventcode",
            label: "Event",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
          // {
          //   key: "datebooked",
          //   label: "Booked",
          //   sortable: true,
          //   class: "text-center d-none d-sm-table-cell",
          //   formatter: (value, key, item) => {
          //     let result = "";
          //     if (value) {
          //       result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
          //     }
          //     return result;
          //   },
          // },
          {
            key: "blac",
            label: "BL A/C",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          // {
          //   key: "cargroup",
          //   label: "Car Group",
          //   sortable: true,
          //   class: "text-center d-none d-xl-table-cell",
          // },
          {
            key: "confirmationno",
            label: "Conf No",
            sortable: true,
            class: "text-center d-none d-xl-table-cell",
          },
          {
            key: "pickupdate",
            label: "Date Pickup",
            sortable: true,
            class: "text-center d-none d-xl-table-cell",
            // formatter: (value, key, item) => {
            //   let result = "";
            //   if (value) {
            //     result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
            //   }
            //   return result;
            // },
          },
          {
            key: "dropoffdate",
            label: "Date Dropoff",
            sortable: true,
            class: "text-center d-none d-xl-table-cell",
            // formatter: (value, key, item) => {
            //   let result = "";
            //   if (value) {
            //     result = this.$moment.unix(value / 1000).format("DD/MM/YYYY");
            //   }
            //   return result;
            // },
          },
          {
            key: "duration",
            label: "Days",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          // {
          //   key: "old",
          //   label: "Old",
          //   sortable: true,
          //   class: "text-center d-none d-sm-table-cell",
          //   formatter: (value, key, item) => {
          //     let result = "";
          //     let dropoff = this.$moment.unix(item.dropoffdate / 1000);
          //     let pickup = this.$moment.unix(item.pickupdate / 1000);
          //     let diff = dropoff.diff(pickup, "days") + 1; // =1
          //     if (diff) {
          //       result = diff;
          //     }
          //     return result;
          //   },
          // },
          {
            key: "invoiceno",
            label: "Invoice",
            sortable: true,
            class: "d-none d-sm-table-cell",
          },
          {
            key: "total",
            label: "Total",
            sortable: true,
            class: "text-right",
            formatter: (value, key, item) => {
              if (value) {
                return parseFloat(value).toFixed(2);
              } else {
                return value;
              }
            },
          },
          {
            key: "status",
            label: "Status",
            sortable: true,
            class: "text-center d-none d-sm-table-cell",
          },
          {
            key: "agent",
            label: "Agent",
            sortable: true,
            class: "d-none d-xl-table-cell",
          },
          {
            key: "actions",
            label: "Actions",
            class: "actions w-130px",
          },
        ],
        badges: [
          {
            key: "status",
            type: "badge",
            Invoiced: "primary",
            Cancelled: "danger",
            New: "info",
            Pending: "danger",
            Failed: "danger",
            Vouchered: "warning",
            Queued: "secondary",
            "On Hold": "warning",
            formatter: (value, key, item) => {
              switch (value) {
                case "ID":
                  return "Invoiced";
                  break;
                case "AA":
                  return "On Hold";
                  break;
                case "CX":
                  return "Cancelled";
                  break;
                case "IF":
                  return "Failed";
                  break;
                case "IQ":
                  return "Queued";
                  break;
                case "ST":
                  return "New";
                  break;
                case "VD":
                  return "Vouchered";
                  break;
                case "WI":
                  return "Pending";
                  break;
                default:
                  return value;
              }
            },
          },
        ],
        actions: [
          {
            key: "edit",
            label: "Edit",
            icon: "fa fa-pencil",
            single: true,
            multiple: false,
            component: {
              name: "CarBookingsEdit",
            },
          },
          {
            key: "view",
            label: "View",
            icon: "fa fa-search-plus",
            single: true,
            multiple: false,
            component: {
              name: "CarVoucher",
            },
          },
          {
            key: "invoice",
            label: "Invoice",
            icon: "fa fa-wpforms text-info",
            single: true,
            multiple: false,
            component: {
              name: "CarInvoiceEdit",
            },
          },
          // {
          //   key: "download",
          //   label: "download",
          //   icon: "fa fa-cloud-upl text-secondary",
          //   class: "text-info",
          //   single: true,
          //   multiple: false,

          // },
        ],
        actions_as_elipses: false,
        modal: {},
        component: {},
        overlay_show: false,
        overlay: {},
      },
    };
  },
  async mounted() {
    // // ONLY ADD ACTIONS IF THE ARRAY EXISTS AND NOT ALREADY ADDED AT CONTROLLED WIDTH
    if (this.options.actions) {
      if (this.options.fields.some((e) => e.key === "actions")) {
      } else {
        this.options.fields.push({
          key: "actions",
          label: "",
          class: "actions w-140px",
        });
      }
    }
    if (this.user.permissions.includes("cars.delete")) {
      this.options.actions.push({
        key: "delete",
        label: "Delete",
        icon: "fa fa-trash text-danger",
        single: true,
        multiple: true,
        overlay: {
          message:
            "Are you sure you want to delete car %driver% with confirmation %confirmationno% ?",
          buttons: [
            {
              label: "Yes",
              variant: "danger",
              dispatch: "delete",
            },
            {
              label: "No",
              class: "ml-2",
            },
          ],
        },
      });
    }
    this.resizableColumns();

    // Mix common tools with local tools
    this.tools = [...this.tools, ...this.options.tools];
    this.toolRemove("copy,import,archive");
    this.toolComponents([
      { action: "add", name: "CarBookingsEdit" },
      { action: "edit", name: "CarBookingsEdit" },
      { action: "view", name: "CarVoucher" },
    ]);

    this.load();
  },

  methods: {
    async load(offset, limit) {
      if (!offset) {
        this.currentpage = 1;
        offset = 0;
      }

      this.btable_items = [];

      console.log("load()");
      // NO WILDCARD SEARCHES
      if (
        !this.driver &&
        !this.slac &&
        !this.eventcode &&
        !this.datepickup.startDate &&
        !this.datepickup.endDate &&
        !this.blac &&
        !this.event &&
        !this.invoiceno &&
        !this.status &&
        !this.isfuture
      ) {
        return;
      }

      this.btable_busy = true;

      let variables = {
        offset,
        limit: limit ? limit : this.limit,
        eventcode: this.eventcode,
        agent: this.agent,
        slac: this.slac,
        invoiceno: this.invoiceno,
        driver: this.driver,
        confirmationno: this.confirmationno,
        datepickupfrom: this.datepickup.startDate,
        datepickupto: this.datepickup.endDate,
        blac: this.blac,
        status: this.status,
        isvouchered: this.isvouchered,
        isfuture: this.isfuture,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query carbookings(
              $limit: Int
              $offset: Int
              $id: String
              $datepickupfrom: String
              $datepickupto: String
              $slac: String
              $blac: String
              $driver: String
              $invoiceno: String
              $confirmationno: String
              $eventcode: String
              $agent: String
              $status: String
              $isvouchered: String
              $isfuture: String
              $dateformat: String
            ) {
              carbookings(
                limit: $limit
                offset: $offset
                id: $id
                datepickupfrom: $datepickupfrom
                datepickupto: $datepickupto
                slac: $slac
                blac: $blac
                driver: $driver
                invoiceno: $invoiceno
                confirmationno: $confirmationno
                eventcode: $eventcode
                agent: $agent
                status: $status
                isvouchered: $isvouchered
                isfuture: $isfuture
                dateformat: $dateformat
              ) {
                id
                eventcode
                slac
                driver
                pickupdate
                dropoffdate
                duration
                cargroup
                datebooked
                confirmationno
                car
                blac
                voucher
                invoiceno
                total: saletotal
                status
                agent
                rows
              }
            }
          `,
          variables,
        });

        if (limit > this.limit) {
          return response.data.carbookings;
        }

        this.btable_items = response.data.carbookings;
        if (response.data.cars.length > 0) {
          this.rows = response.data.cars[0].rows;
        }

      } catch (error) {
        console.log(error);
      }
      this.btable_busy = false;
    },
    async _toolClick(a) {
      console.log("local toolClick: ", a);
      // this.cconfig.find((o) => o.key == "eventcode").value = this.eventcode;
      switch (a) {
        case "delete":
          await this.deleteit();
          break;
      }
      return;
    },
    _toolDisabled(a) {
      console.log("local toolDisabled: ", a);
      switch (a) {
        case "view":
          return this.btable_selected.length > 0 ? false : true;
      }
    },

    async deleteit() {
      let variables = {
        id: this.btable_selected[0].id,
      };
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation deletecar($id: String) {
              deletecar(id: $id)
              # id
            }
          `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }
      await this.load();
    },

    // async deleteit() {
    //   let variables = {
    //     rows: this.cleanit(this.btable_selected),
    //   };
    //   try {
    //     const response = await this.$apollo.mutate({
    //       mutation: gql`
    //         mutation deletecar($rows: [Carbooking_input]) {
    //           deletecar(rows: $rows) {
    //             id
    //           }
    //         }
    //       `,
    //       variables,
    //     });
    //   } catch (error) {
    //   }
    //   await this.load();
    // },

    treeselect(n) {
      this.search.event_name = n.label;
    },
  },
};
</script>

<style>
</style>